import React, { useContext } from 'react';
import axios from 'axios';
import { get, map } from 'lodash';
import classnames from 'classnames';
import { ModalBody, Modal, ModalHeader, ModalFooter } from 'reactstrap';
import ReactPaginate from 'react-paginate';
import CardReference from '../components/CardReference';
import ListTag from '../components/ListTag';
import Item from '../components/Item';
import Loading from '../components/Loading';
import BaseFiltroAvancadoItem from './BaseFiltroAvancadoItem';
import { API_HOST } from '../consts';
import {
  BaseFiltroAvancadoItemStyleButton,
  BaseFiltroAvancadoItemStyleTextColor
} from './styles';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  IconButton,
  Button
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import {
  AtividadesContainer,
  DivBtn,
  DivH1,
  FiltrosContainer,
} from '../pages/avaliacoes/Styled/ItemStyles';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'

class BaseFiltroAvancadoItemAvaliacao extends BaseFiltroAvancadoItem {
  constructor(props) {
    super(props);
    this.firstTimeOpening = true;
  }

  state = {
    itens: [],
    activeTab: 'filtros',
    total: 0,
    sortBySearchedIdOrder: true,
    sortBySearchedExternalIdOrder: true,
    selectAll: false,
    disabled: false,
    avaliacaoPublic: false,
    avaliacaoPPI: false,
  };

  handleOrderBySearchIdCheckboxChange = (event) => {
    const value = event.target.checked;
    this.setState({
      sortBySearchedIdOrder: value
    });
  };

  handleSubmit = () => {
    this.setState({ activeTab: 'resultados', fetchingData: true });

    const { values } = this.formApi.getState();
    const { page, page_size } = this.state;

    axios
      .get(`${API_HOST}/itens/item`, {
        params: {
          page,
          page_size,
          ...this.getValues(values)
        }
      })
      .then((response) => {
        this.setState({
          fetchingData: false,
          itens: response.data.results,
          total: response.data.count,
          total_pages: response.data.total_pages
        });
      });
  };
  getExamStatus = () => {
    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/get_get_public_status?id=${50}`)
      .then((response) => {
        this.setState({
          avaliacaoPublic: response.data.publico
        });
      });
  };

  handleAddAll = (event) => {
    const { onAddAll } = this.props;
    const { values } = this.formApi.getState();
    const value = event.target.checked;
    this.setState({
      selectAll: value
    });
    if (value) {
      onAddAll(this.getValues(values));
      this.formApi.reset();
    }
  };

  mapItem = (item) => {
    const { checked } = this.props;

    return (
      <>
        <div className="col-md-12 mb-3" key={item.id}>
          <CardReference
            descricao={
              <div className="row">
                <div className="col-md-9 list-data-title">
                  <h3>
                    Objeto de aprendizagem {item.id} - Código externo{' '}
                    {item.external_id}
                  </h3>
                </div>
                <div className="col-md-3 mb-3">
                  <ListTag
                    label={get(item, 'status.descricao')}
                    color={get(item, 'status.cor')}
                  />
                </div>
                <div className="col-md-12">
                  <Item item={item} />
                </div>
              </div>
            }
            onChange={(event) =>
              this.handleCheckboxChange(
                event,
                item.id,
                item.publico,
                this.props.isPublic
              )
            }
            checked={checked.find((id) => id === item.id)}
            disabled={(event) =>
              this.handleCheckboxChange(
                event,
                item.id,
                item.publico,
                this.props.isPublic
              )
            }
            borderRight={false}
          />
        </div>
      </>
    );
  };

  getItensByOrderedIds = (ids) => {
    const { itens } = this.state;
    const orderedItens = [];
    ids.forEach((id) =>
      orderedItens.push(itens.filter((item) => item.id === id))
    );
    return orderedItens.flat();
  };

  getItensNotInIds = (ids) => {
    const { itens } = this.state;
    return itens.filter((item) => !ids.includes(item.id));
  };

  getSearchedIdsIntList = () => {
    const idFieldString = this.formApi.getState().values.id;
    if (idFieldString) {
      return idFieldString.split(',').map((id) => parseInt(id, 10));
    }
    return null;
  };

  mapBySearchIdsOrder = () => {
    const { itens } = this.state;
    const ids = this.getSearchedIdsIntList();
    if (ids) {
      const sortedItens = this.getItensByOrderedIds(ids);
      const itensNotInIds = this.getItensNotInIds(ids);
      return map([...sortedItens, ...itensNotInIds], this.mapItem);
    }
    return map(itens, this.mapItem);
  };

  changePage = (pagination) => {
    this.setState({ fetchingData: true });
    const page = pagination.selected + 1;
    this.setState({ page }, this.handleSubmit);
  };

  renderPagination() {
    const { page, itens, total_pages, fetchingData } = this.state;

    if (fetchingData) {
      return null;
    }

    if (itens.length > 0) {
      return (
        <nav style={{ textAlign: 'center' }}>
          <ReactPaginate
            pageCount={total_pages}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            previousLabel="ANTERIOR"
            nextLabel="PRÓXIMA"
            onPageChange={this.changePage}
            initialSelected={page}
            forcePage={page - 1}
            containerClassName="pagination"
            activeClassName="active"
            disabledClassName="disabled"
            disableInitialCallback
            breakLabel={<button className="disabled">...</button>}
          />
        </nav>
      );
    }

    return null;
  }

  displayItemResults = () => {
    const { itens, sortBySearchedIdOrder, dados} = this.state;
    if (itens.length > 0) {
      return sortBySearchedIdOrder
        ? this.mapBySearchIdsOrder()
        : map(itens, this.mapItem);
    }
    return null;
  };

  orderBy = (e) => {
    const params = {
      area_conhecimento: this.state.areasConhecimentoId,
      componente_curricular:this.state.componenteCurricularId,
      matriz_referencia: this.matrizReferenciaId,
      periodo:this.state.anoId,
      curso:this.state.cursoId,
      ordering: e && e
    }
    axios
      .get(`${API_HOST}/itens/item`,{params})
      .then((response) => {
        this.setState({
          itens: response.data.results
        });
      });
  }
  renderResults() {
    const { fetchingData, total, sortBySearchedIdOrder, selectAll } = this.state;
    const { onAddAll } = this.props;

    return (
      <React.Fragment>
        <DivH1 testId="div-heder">
          <Typography
            style={{
              color: "#333",
              fontFamily: "Public Sans",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "normal",
              marginTop: '5px'
            }}
          >
            Objetos encontrados
          </Typography>

          <DivBtn>
              <UncontrolledDropdown>
                <DropdownToggle
                  style={{
                    width: 'auto',
                    padding: '8px 15px 8px 15px',
                    background: "#CBE4FF",
                    borderRadius: "24px",
                    boxShadow: "2px 2px 7px 0px rgba(0, 0, 0, 0.25)",
                    height: "30px",
                    border: "none",
                    outline: "none",
                    textTransform: "capitalize",
                    display: 'flex',
                    alignItems: 'center'

                  }} >
                  <Typography
                    style={{
                      fontFamily: 'Public Sans',
                      fontSize: '16px',
                      fontWeight: 700,
                      lineheight: '24px',
                      letterSpacing: '0em',
                      textAlign: 'center',
                      color: "#0047B6",
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    Ordenar
                    <i style={{ marginLeft: '5px', color: "#0047B6", fontSize: '30px' }} className="icon-Arrow-tip-down" />
                  </Typography>
                </DropdownToggle>
                  <DropdownMenu style={{
                    fontFamily: 'Public Sans',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '19px',
                    letterSpacing: '0em',
                    textAlign: 'left'
                  }}>
                  {/* <DropdownItem onClick={() => this.orderBy() }>Mais utilizados</DropdownItem> */}
                  <DropdownItem onClick={() => this.orderBy('-id')} >Mais recente</DropdownItem>
                  <DropdownItem  onClick={() => this.orderBy('id')}>Mais antigo</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

            <Button
              style={{
                padding: '8px 15px 8px 15px',
                background: "#0047B6",
                borderRadius: "24px",
                boxShadow: "2px 2px 7px 0px rgba(0, 0, 0, 0.25)",
                height: "30px",
                border: "none",
                outline: "none",
                textTransform: "capitalize",
              }}
              onClick={() => {
                const newTab = window.open(`/itens/new/dados?id=${this.props.match.params.id}`, '_blank');
                newTab.focus();
              }}
            >
              <i style={{ marginRight: '10px', color: '#FFFFFF', }} className="fas fa-plus" />
              <Typography
                style={{
                  fontFamily: 'Public Sans',
                  fontSize: '16px',
                  fontWeight: 700,
                  lineheight: '24px',
                  letterSpacing: '0em',
                  textAlign: 'center',
                  color: '#FFFFFF',
                }}
              >
                Criar Objeto
              </Typography>
            </Button>
          </DivBtn>
        </DivH1>
        <BaseFiltroAvancadoItemStyleTextColor>
        </BaseFiltroAvancadoItemStyleTextColor>

        {onAddAll && total > 0 && this.shouldDisplay('avaliacao.selecionarTodos') && (
          <p
            className="select-item-help form-text text-muted"
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            Clique na caixa de seleção ao lado do Objeto de aprendizagem para
            adicioná-lo a atividade cognitivo.
          </p>
        )}

        <div className="pr-3 pl-3">
          <div style={{
            padding: '12px',
            borderRadius: '4px',
            gap: '12px',
            backgroundColor: '#F7F7F7',
            display: 'flex',
            marginBottom: '12px',
            width: '100%'
          }}>
            <div style={{ alignSelf: 'center', display: 'flex' }}>
              <input
                name="selectAll"
                type="checkbox"
                checked={selectAll}
                onChange={this.handleAddAll}
                style={{ marginRight: '5px' }}
              />
              <Typography
                style={{
                  color: "#333333",
                  fontFamily: "Public Sans",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "18.8px",
                }}
              >
                Selecionar todos os <strong>{total}</strong> objetos
              </Typography>
            </div>
          </div>

          {fetchingData && <Loading />}
          {!fetchingData && (
            <React.Fragment>
              <div className="row">{this.displayItemResults()}</div>
              {this.renderPagination()}
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }

  renderFooter() {
    const { activeTab, fetchingData } = this.state;

    if (activeTab === 'filtros') {
      return (
        <ModalFooter
          style={{ display: 'flex', justifyContent: 'center', margin: '10px' }}
        >
          <button
            className="btn danger-button"
            style={{
              marginTop: '10px',
              borderRadius: '70px',
              background: '#E4E4E4',
              boxShadow: '2px 2px 7px rgba(0, 0, 0, 0.25)',
              color: '#878787',
              padding: '5px 20px',
              marginRight: '26px'
            }}
            type="button"
            onClick={this.toggle}
          >
            Cancelar
          </button>
          <BaseFiltroAvancadoItemStyleButton>
            <button
              className="btn primary-button button-primary"
              style={{
                marginTop: '10px',
                borderRadius: '70px',
                boxShadow: '2px 2px 7px rgba(0, 0, 0, 0.25)',
                padding: '5px 20px'
              }}
              type="button"
              onClick={this.handleSubmit}
              disabled={fetchingData}
            >
              {fetchingData ? 'Buscando...' : 'Buscar'}
            </button>
          </BaseFiltroAvancadoItemStyleButton>
        </ModalFooter>
      );
    }

    if (activeTab === 'resultados') {
      return (
        <ModalFooter
          style={{ display: 'flex', justifyContent: 'center', margin: '10px' }}
        >
          <BaseFiltroAvancadoItemStyleButton>
            <button
              className="button-newSearch"
              style={{
                marginRight: '25px',
                marginTop: '10px',
                borderRadius: '70px',
                padding: '5px 20px',
                boxShadow: '2px 2px 7px rgba(0, 0, 0, 0.25)',
                color: '#6A35DD',
                borderColor: '#6A35DD',
                borderWidth: '1px',
                background: '#fff'
              }}
              type="button"
              onClick={() => this.setState({ activeTab: 'filtros' })}
            >
              Nova busca
            </button>
          </BaseFiltroAvancadoItemStyleButton>
          <BaseFiltroAvancadoItemStyleButton>
            <button
              className="btn primary-button button-primary"
              style={{
                marginTop: '10px',
                borderRadius: '70px',
                padding: '5px 20px',
                boxShadow: '2px 2px 7px rgba(0, 0, 0, 0.25)'
              }}
              type="button"
              onClick={this.toggle}
            >
              Concluir
            </button>
          </BaseFiltroAvancadoItemStyleButton>
        </ModalFooter>
      );
    }

    return null;
  }

  render() {
    const { isOpen } = this.props;
    const { activeTab } = this.state;
    const styles = (theme) => ({
      root: {
        margin: 0,
        padding: theme.spacing(2),
        display: "flex",
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      closeButton: {
        right: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });


    const DialogTitle = withStyles(styles)((props) => {
      const { children, classes, onClose, ...other } = props;
      return (
        <MuiDialogTitle disableTypography className={classes.root} {...other} >
          <Typography
            variant="h6"
            style={{
              color: "#333",
              fontFamily: 'Public Sans',
              fontSize: '20px',
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "normal",
            }}
          >
            {children}
          </Typography>

          <IconButton onClick={this.toggle} >
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
      );
    });


    return (
      <Dialog
        open={isOpen}
        toggle={this.toggle}
        maxWidth="lg"
        fullWidth={false}
        aria-labelledby="responsive-dialog-title"
        onEnter={this.onOpened}
        onClosed={this.onExit}
      >

        <DialogTitle toggle={this.toggle}>Banco de Objetos de Aprendizagem</DialogTitle>

        <DialogContent dividers >
          <Grid container >
            <Grid item xs={12} md={4}>
              <FiltrosContainer>
                {this.renderForm()}
              </FiltrosContainer>

            </Grid>
            <Grid item xs={12} md={8}>
              <AtividadesContainer>
                {this.renderResults()}
              </AtividadesContainer>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions style={{ padding: "12px 30px 12px 0px" }}>
          <Button
            style={{
              width: "149px",
              padding: "9px 30px",
              gap: "15px",
              borderRadius: "70px",
              background: "#E4E4E4",
              boxShadow: "2px 2px 7px 0px rgba(0, 0, 0, 0.25)",
              textTransform: "capitalize",
            }}
          >
            <Typography
              style={{
                color: "#878787",
                fontFamily: "Public Sans",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: '0em',
                textAlign: 'center',
              }}
              onClick={this.toggle}
            >
              Cancelar
            </Typography>
          </Button>

          <Button
            style={{
              width: "149px",
              padding: "9px 30px",
              gap: "15px",
              borderRadius: "70px",
              background: "#0047B6",
              boxShadow: "2px 2px 7px 0px rgba(0, 0, 0, 0.25)",
              textTransform: "capitalize",
            }}
            onClick={this.toggle}
          >
            <Typography
              style={{
                color: "#FFFFFF",
                fontFamily: "Public Sans",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: '0em',
                textAlign: 'center',

              }}
            >
              Adicionar
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default BaseFiltroAvancadoItemAvaliacao;
